import React, { useState } from "react";
import { DatePicker, Form, Input } from "antd";
import moment from "moment";
import {
  DynamicCol,
  GutteredRow,
} from "../../common/components/AreasPositions/Grid";
import DeactivationConfirmationModal from "../../common/components/AreasPositions/DeactivateConfirmationModal";
import { maxValueRule } from "../../utils/input";

const AreaEditForm = ({ form, area }) => {
  const [endDateState, setEndDateState] = useState({
    open: false,
    value: undefined,
    agreement: false,
  });

  const onOk = () => {
    setEndDateState((oldState) => ({
      ...oldState,
      agreement: true,
      open: true,
    }));
  };

  const start_date = moment(new Date(area.current_record.timespan.lower));
  return (
    <Form layout={"vertical"} form={form}>
      <GutteredRow>
        <DynamicCol>
          <Form.Item
            label="Nome da Área:"
            name="name"
            initialValue={area.name}
            rules={[
              { required: true, message: "Por favor insira o nome da área." },
              maxValueRule(200),
            ]}
          >
            <Input />
          </Form.Item>
        </DynamicCol>
        <DynamicCol>
          <Form.Item
            label="Código:"
            name="code"
            initialValue={area.code}
            rules={[
              { required: true, message: "Por favor insira o código da área." },
              maxValueRule(50),
            ]}
          >
            <Input />
          </Form.Item>
        </DynamicCol>
      </GutteredRow>
      <GutteredRow>
        <DynamicCol>
          <Form.Item
            label="Data de criação"
            name="start_date"
            initialValue={start_date}
            rules={[
              {
                required: true,
                message: "Por favor insira a data de criação.",
              },
            ]}
          >
            <DatePicker
              placeholder={"Selecione uma data"}
              format={"DD/MM/YYYY"}
              disabledDate={(current) => {
                return (
                  current &&
                  form.getFieldValue("end_date") &&
                  current > form.getFieldValue("end_date").startOf("day")
                );
              }}
            />
          </Form.Item>
        </DynamicCol>
        <DynamicCol>
          <Form.Item
            label="Data de fim da área"
            name="end_date"
            rules={[
              {
                validator: async (_, endDate) => {
                  let startDatetime = form.getFieldValue("start_date");

                  if (endDate && endDate <= startDatetime) {
                    return Promise.reject(
                      "A data de fim da área deve ser maior que a data de inicio!",
                    );
                  }
                },
              },
            ]}
          >
            <DatePicker
              placeholder={"Selecione uma data"}
              format={"DD/MM/YYYY"}
              value={endDateState.value}
              disabledDate={(current) => {
                return (
                  current &&
                  current < form.getFieldValue("start_date").endOf("day")
                );
              }}
              onClick={() =>
                endDateState.agreement
                  ? setEndDateState((oldState) => ({
                      ...oldState,
                      open: true,
                    }))
                  : DeactivationConfirmationModal({
                      title: "Inativar Área?",
                      content:
                        "Ao definir uma data final da área, ela se torna inativa e não será possível atribuir à funcionários. Tem certeza que deseja continuar?",
                      onOk,
                    })
              }
              onChange={(value) =>
                setEndDateState((oldState) => ({
                  ...oldState,
                  open: false,
                  value: value,
                }))
              }
              onBlur={() =>
                setEndDateState((oldState) => ({ ...oldState, open: false }))
              }
              open={endDateState.open}
            />
          </Form.Item>
        </DynamicCol>
      </GutteredRow>
    </Form>
  );
};

export default AreaEditForm;
